module.exports = __webpack_public_path__ + "img/alert.87aeccab.svg";